import { useMutation } from '@tanstack/react-query';
import { affiliateService } from 'shared/src/api';
import type { PostAffiliateLinksAccessLogsRequest } from 'shared/src/api';

export const usePostAffiliateLinksAccessLogs = () => {
  return useMutation({
    throwOnError: false,
    mutationFn: (data: PostAffiliateLinksAccessLogsRequest) =>
      affiliateService.postAffiliateLinksAccessLogs(data),
  });
};
